import { getSpace } from '@tamagui/get-token';
import React from 'react';
import {
  Paragraph,
  SizableStackProps,
  Tooltip as TMTooltip,
  TooltipProps as TooltipPropsBase
} from 'tamagui';

export type TooltipProps = TooltipPropsBase & {
  disabled?: boolean;
  label?: React.ReactNode;
  children?: React.ReactNode;
  contentProps?: SizableStackProps;
};

export const Tooltip: React.FC<TooltipProps> = ({
  label,
  children,
  contentProps,
  disabled,
  placement = 'top',
  ...tooltipProps
}) => {
  const child = React.Children.only(children);
  const space = getSpace(tooltipProps.size || '$true', {
    shift: -4
  });

  if (!label) {
    return children;
  }

  return (
    <TMTooltip
      disableRTL
      offset={15}
      restMs={100}
      delay={100}
      placement={placement}
      {...tooltipProps}
      {...(disabled ? { open: false } : null)}
    >
      <TMTooltip.Trigger
        {...(typeof label === 'string' && {
          'aria-label': label
        })}
        asChild="except-style"
      >
        {child}
      </TMTooltip.Trigger>

      <TMTooltip.Content
        theme={'surface1'}
        zIndex={1_000_000_000}
        pointerEvents="none"
        elevation="$0.5"
        py={space}
        transition={'quicker'}
        animateOnly={['transform', 'opacity']}
        enterStyle={{ y: -4, opacity: 0, scale: 0.96 }}
        exitStyle={{ y: -4, opacity: 0, scale: 0.96 }}
        {...contentProps}
      >
        <TMTooltip.Arrow theme={'surface1'} />
        <Paragraph size="$3">{label}</Paragraph>
      </TMTooltip.Content>
    </TMTooltip>
  );
};

Tooltip.displayName = 'Tooltip';
